import React from "react"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"
import {
  BdTitle3,
  RegBody,
  SemiBdTitle3,
  SemiBdTitle6,
} from "@sr/gatsby-theme-ui"

export interface ProductEntryKpisPropsShape {
  kpis: {
    on: boolean
    header: string
    subHeader: string
    statisticsCopy: string
    kpisList: {
      statistic: string
      body: string
    }[]
  }
}

const ProductEntryKpis = ({ kpis }: ProductEntryKpisPropsShape) => {
  return (
    <ProductEntryKpisStyled>
      <div className="product-entry__kpis-header-container">
        <SemiBdTitle3>{kpis?.header}</SemiBdTitle3>
        <RegBody>{kpis?.subHeader}</RegBody>
      </div>
      <div className="product-entry__kpis-data-container">
        {kpis?.kpisList
          ? kpis?.kpisList?.map((kpi, i: number) => {
              return (
                <div className="product-entry__kpis-data-kpi" key={i}>
                  <BdTitle3 className="product-entry__kpis-data-kpi-statistic">
                    {kpi.statistic}
                  </BdTitle3>
                  <SemiBdTitle6 className="product-entry__kpis-data-kpi-body">
                    {kpi.body}
                  </SemiBdTitle6>
                </div>
              )
            })
          : null}
      </div>
      {kpis?.statisticsCopy ? (
        <RegBody className="product-entry__kpis-date">
          {kpis?.statisticsCopy}
        </RegBody>
      ) : null}
    </ProductEntryKpisStyled>
  )
}

export default ProductEntryKpis

const ProductEntryKpisStyled = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${rem(48)} ${rem(40)};
  width: 100%;
  background-color: var(--color-gray900);

  @media ${media.midUp} {
    padding: ${rem(72)} ${rem(172)};
  }

  @media ${media.stMidUp} {
    padding: ${rem(120)} ${rem(172)};
  }

  .product-entry__kpis-header-container {
    display: flex;
    flex-direction: column;
    gap: ${rem(8)};
    text-align: center;
    max-width: ${rem(294)};

    @media ${media.midUp} {
      max-width: ${rem(491)};
      gap: ${rem(16)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(705)};
    }

    h3 {
      font-size: ${rem(32)};
      line-height: ${rem(40)};
      color: var(--color-primary);

      @media ${media.midUp} {
        font-size: ${rem(40)};
        line-height: ${rem(48)};
      }
    }

    p {
      color: var(--color-white);

      @media ${media.midUp} {
        font-size: ${rem(20)};
        line-height: ${rem(32)};
      }
    }
  }
  .product-entry__kpis-data-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: ${rem(54)};
    margin-top: ${rem(24)};
    margin-bottom: ${rem(40)};

    @media ${media.stUp} {
      margin: ${rem(72)} 0 ${rem(40)};
      }

    .product-entry__kpis-data-kpi {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      height: 100%;
      width: 50%;

      @media ${media.stUp} {
        width: 32%;
      }

      h3 {
        color: var(--color-white);
      }

      h6 {
        color: var(--color-gray400);
        padding-top: ${rem(16)};
      }

      @media ${media.stUp} {
        border-right: 1px solid var(--color-gray700);
        height: ${rem(160)};
      }
    }

    .product-entry__kpis-data-kpi:last-child {
      @media ${media.stUp} {
        border: none;
      }
    }
  }

  .product-entry__kpis-date {
    color: var(--color-white);
    margin: ${rem(16)} 0;
    font-size: ${rem(12)};
    @media ${media.stUp} {
      /* margin-bottom: ${rem(52)}; */
    }
  }
`
